import React from 'react';
import { Classes } from '../index';
type noDataProps = {
  /*
   * Překrytí defaultního textu
   */
  children?: React.ReactNode;
};
export const NoData: React.FC<noDataProps> = ({ children }) => {
  return (
    <div className={Classes.NO_DATA}>
      {children ? children : 'Žádné záznamy'}
    </div>
  );
};
